
/**
 * @file Used to determine the current mode of the application
 * @author jesposito
 */

export enum Mode {
	DEV,
	PROD
}

declare var process: any;

const getMode = (): Mode => {
	return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') ? Mode.DEV : Mode.PROD;
};

export class EnvMode {
	private mode: Mode;

	constructor() {
		this.mode = getMode();
	}

	public get() {
		return this.mode;
	}

	public isDev() {
		return this.mode === Mode.DEV;
	}

	public isProd() {
		return this.mode === Mode.PROD;
	}

	public getName() {
		return this.isDev() ? "development" : "production";
	}
}

export const currentMode = new EnvMode();



// WEBPACK FOOTER //
// ./src/core/util/Mode.ts